/** Copyright (c) 2020 T.Rowe Price. All rights reserved. */

import './AccountCenterPage.scss';

import { isNil } from 'lodash';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';
import {
  accountCenterSrcURL,
  externalInvestmentLinks,
  yodleeAggregationServiceTerms
} from 'services/Externals';
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';
import BaseModal from 'components/shared/Modal/BaseModal';
import Content from 'services/Content';
import YodleeTermsOfUseAndPrivacyPolicy from 'components/shared/Yodlee/YodleeTermsOfUseAndPrivacyPolicy';
import Store from 'state/Store';
import { getActiveVendorSessions } from 'state/session/SessionSelectors';
import { Link } from 'react-router-dom';
import { getExternalInvestmentConsent } from 'state/external/ExternalInvestmentConsentSelectors';
import {
  hasActiveExternalAccountSession,
  activateExternalAccountSession
} from 'components/layouts/ExternalInvestmentProductCard/NewExternalInvestmentProductCard';
import { expireVendorSession } from 'state/session/SessionActions';
import { getQueryParams } from 'state/session/SessionSelectors';
import { ReactComponent as YodleeLogo } from 'assets/logo/logo-yodlee.svg';
import {
  refreshExternalInvestmentBalances,
  getExternalInvestmentSource
} from 'services/Rest';
import { mapProductTypeToiiFooterBoolean } from '../../../state/account/AccountSelectors';
import AAMFooterContainer from '../../layouts/Footer/FooterUtil';
import { isMobile } from 'state/view/ViewSelectors';

class AccountCenterPage extends React.Component {
  state = {
    frameSrc: '',
    yodleeTermsOfUseModalOpen: false,
    yodleePrivacyPolicyModalOpen: false
  };

  componentDidMount() {
    this.checkToHideNavigation();
    activateExternalAccountSession();
    const { params, activeVendorSessions } = this.props;
    const { TARGET_URL } = params;
    const targetParam = TARGET_URL ? `&TARGET_URL=${TARGET_URL}` : '';

    if (
      hasActiveExternalAccountSession(activeVendorSessions) ||
      !activeVendorSessions.length
    ) {
      getExternalInvestmentSource(
        `${accountCenterSrcURL}?extraParams=${encodeURIComponent(
          'locationurl=' +
            document.location.origin +
            '&iframeResize=true' +
            targetParam
        )}`
      ).then((htmlSource) => {
        this.setState({
          frameSrc: `data:text/html;charset=utf-8,${escape(htmlSource)}`
        });
      });
    } else {
      this.setState({ frameSrc: externalInvestmentLinks.logout });
    }
  }

  componentDidUpdate() {
    this.checkToHideNavigation();
  }

  handleLogout = () => {
    const { activeVendorSessions } = this.props;

    refreshExternalInvestmentBalances();
    if (hasActiveExternalAccountSession(activeVendorSessions)) {
      Store.dispatch(expireVendorSession('externalAccount'));
    }
  };

  checkToHideNavigation = () => {
    // Hide the navigation part of the header using
    // setInterval
    if (typeof window.headerIntervalId === 'undefined') {
      window.headerIntervalId = setInterval(() => {
        const navTag = document.querySelector('.pi-shared-nav-header-nav');
        if (navTag) {
          navTag.style.display = 'none';
          clearInterval(window.headerIntervalId);
        }
      }, 1000);
      // Fallback to timeout in case of infinite loop
      setTimeout(() => {
        clearInterval(window.headerIntervalId);
      }, 10000);
    }
  };

  handleYodleeTermsOfUseModal = () =>
    this.setState((state) => {
      const { yodleeTermsOfUseModalOpen } = state;
      return { yodleeTermsOfUseModalOpen: !yodleeTermsOfUseModalOpen };
    });

  handleYodleePrivacyPolicyModal = () =>
    this.setState((state) => {
      const { yodleePrivacyPolicyModalOpen } = state;
      return { yodleePrivacyPolicyModalOpen: !yodleePrivacyPolicyModalOpen };
    });

  render() {
    const { hasConsent, footerProductTypes, isMobileApp } = this.props;
    const {
      frameSrc,
      yodleeTermsOfUseModalOpen,
      yodleePrivacyPolicyModalOpen
    } = this.state;

    return isNil(hasConsent) ? null : !hasConsent ? (
      <Redirect to="/dashboard" />
    ) : (
      <Fragment>
        <div className="account-center-header">
          <div className="account-center-header-container">
            <h1 className="account-center-header-title">Account Center</h1>
            <div className="account-center-close-button-container">
              <Link
                className={'account-center-close-svg'}
                onClick={this.handleLogout}
                to="/dashboard">
                <span className="account-center-close-title">Close</span>
                <span className="svg-icon">
                  <CloseIcon className="account-center-close-button-icon" />
                </span>
              </Link>
            </div>
          </div>
        </div>
        <div className="accountcenter-page">
          <iframe
            id="yodlee-iframe"
            className="external-account-center-iframe-id"
            title="Account Center"
            width="996"
            height="500"
            src={frameSrc}></iframe>
        </div>
        <div className="footer-accountcenter">
          <div className="yodlee-links-container">
            <a
              href={yodleeAggregationServiceTerms}
              target="_blank"
              id="yodlee-service-terms"
              className="account-center-footer-link"
              rel="noreferrer">
              Service Terms
            </a>
            <YodleeLogo className="external-investment-card-bottom-logo" />
          </div>
        </div>

        <BaseModal
          close={this.handleYodleeTermsOfUseModal}
          containerClassName={'yodlee-modal'}
          hideAnchor={true}
          isOpen={yodleeTermsOfUseModalOpen}
          label="yodlee-modal"
          title={'Account Center User Agreement/Terms and Conditions'}
          disableClickOff
          renderModalContent={
            <YodleeTermsOfUseAndPrivacyPolicy
              content={Content.yodleeTermsOfUse}
            />
          }></BaseModal>
        <BaseModal
          close={this.handleYodleePrivacyPolicyModal}
          containerClassName={'yodlee-modal'}
          hideAnchor={true}
          isOpen={yodleePrivacyPolicyModalOpen}
          label="yodlee-modal"
          title={'Account Center Privacy Policy'}
          disableClickOff
          renderModalContent={
            <YodleeTermsOfUseAndPrivacyPolicy
              content={Content.yodleePrivacyPolicy}
            />
          }></BaseModal>
        <AAMFooterContainer
          isMobileParam={isMobileApp}
          footerProductTypes={footerProductTypes}
          appLoaded={true}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  footerProductTypes: mapProductTypeToiiFooterBoolean(state),
  isMobileApp: isMobile(state),
  hasConsent: getExternalInvestmentConsent(state),
  params: getQueryParams(state),
  activeVendorSessions: getActiveVendorSessions(state)
});

export default withRouter(connect(mapStateToProps)(AccountCenterPage));
